import cn from '@/utils/cn'
import timeUtils from '@/utils/time.utils'
import css from './reportTableFooter.module.css'
import { useMemo } from 'react'
import { IMaintenanceEvent, TUnplannedMaintenanceEvent } from '@/pages/Calendar/calendar.types'
import Skeleton from '@/shared/Loaders/Skeleton'

interface IProps {
  days: Date[]
  scrollWidth: number
  events: {
    planned: IMaintenanceEvent[]
    unplanned: TUnplannedMaintenanceEvent[]
  }
  loading: boolean
  hoverCol: number | null
}

const ReportTableFooter = (props: IProps) => {
  const completedMaintenanceEventsByDate = useMemo(() => {
    const map = new Map<string, number>()
    for (let ev of props.events.planned) {
      if (ev.type !== 'COMPLETED_MAINTENANCE') continue
      const key = timeUtils.formatDate(ev.ts, 'yyyy-MM-dd')
      map.set(key, (map.get(key) ?? 0) + 1)
    }
    for (let ev of props.events.unplanned) {
      const key = timeUtils.formatDate(ev.createdAt, 'yyyy-MM-dd')
      map.set(key, (map.get(key) ?? 0) + 1)
    }
    return map
  }, [props.events])

  const renderTotalCell = (date: Date, colIndex: number) => {
    const total = completedMaintenanceEventsByDate.get(timeUtils.formatDate(date, 'yyyy-MM-dd'))

    return (
      <div
        key={colIndex}
        data-hover={colIndex === props.hoverCol}
        className={css.totalCellWrapper}
        data-loading={props.loading}
      >
        <span
          style={{ padding: '12px 0' }}
          className={cn('text-nm', Boolean(total) ? 'text-default' : 'text-placeholder')}
        >
          <Skeleton height="22px" width="12px" style={{ borderRadius: '2px' }} loading={props.loading}>
            {total || 0}
          </Skeleton>
        </span>
      </div>
    )
  }

  return (
    <div className={cn(css.row, css.totalRow)} style={{ paddingRight: `${props.scrollWidth}px` }}>
      <div style={{ display: 'flex', flex: '1 1 0', marginLeft: '304px' }}>{props.days.map(renderTotalCell)}</div>
    </div>
  )
}

export default ReportTableFooter
